import { combineReducers } from '@reduxjs/toolkit';

import appReducer from './app_global/reducer';
import seoReducer from './seo/reducer';
import profileReducer from './profile/reducer';
import locationsReducer from './locations/reducer';
import organizationReducer from './organization/reducer';
import specialistReducer from './specialist/reducer';
import reviewsReducer from './reviews/reducer';
import postsReducer from './posts/reducer';
import specialist_infoReducer from './specialist_info/reducer';
import surveysReducer from './surveys/reducer';
import mp_infoReducer from './mp_info/reducer';
import advertisementReducer from './advertisement/reducer';

const rootReducer = combineReducers({
    app_global: appReducer,
    seo: seoReducer,
    profile: profileReducer,
    locations: locationsReducer,
    organization: organizationReducer,
    specialist: specialistReducer,
    reviews: reviewsReducer,
    posts: postsReducer,
    specialist_info: specialist_infoReducer,
    surveys: surveysReducer,
    advertisement: advertisementReducer,
    mp_info: mp_infoReducer
});

export default rootReducer;